import API from '@/models/API';

export default class RegistrationPlans {
  constructor(item = {}) {
    this.store_subscription_plan_id = item.store_subscription_plan_id || null;
    this.plan_name = item.plan_name || {
      el: '',
      en: '',
      it: '',
    };
    this.plan_description = item.plan_description || {
      el: '',
      en: '',
      it: '',
    };
    this.plan_price = item.plan_price || null;
    this.interval = item.interval || '';
    this.interval_count = item.interval_count || null;
    this.reward_points = item.reward_points || null;
    this.reward_type_id = item.reward_type_id || null;
    this.store_payment_methods = item.store_payment_methods || [];
    this.is_public = item.is_public || false;
    this.extra_properties = item.extra_properties || {
      is_pos: false,
    };
    this.is_credit = item.is_credit || false;
    this.top_up_amount = item.top_up_amount ?? '';
    this.threshold = item.threshold ?? '';
    this.threshold_top_up_amount = item.threshold_top_up_amount ?? '';
    this.attributes = item.attributes || {};
    this.permissions = item.permissions || {};
    this.vat_included = item.vat_included || false;
  }

  static create = (item) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/subscriptions/company-plan`, item);

  static getCompanyAttributes = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/subscriptions/company-attributes`);

  static getCompanyPermissions = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/subscriptions/company-permissions`);
}
